import { PackagingComponentDto } from './packaging-component-dto';

export class MainBodyDto extends PackagingComponentDto {
  isRigidComponent = false;
  packagingVolume?: number;
  description?: string;
}
